import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { BACKEND_URL, COMPANY_ADDRESS, COMPANY_PHONES, COMPANY_EMAIL } from '../config';
import CopyPhoneText from './CopyPhoneText';
import '../css/Footer.css';

const MAX_CATEGORIES = 8;

const Footer = () => {
    const year = new Date().getFullYear();
    const [categories, setCategories] = useState([]);

    useEffect(() => {
        fetch(`${BACKEND_URL}/categories`)
            .then(r => r.ok ? r.json() : [])
            .then(data => setCategories(data.slice(0, MAX_CATEGORIES)))
            .catch(() => {});

    }, []);

    return (
        <footer className="main-footer">
            <div className="footer-inner">
                {categories.length > 0 && (
                    <div className="footer-nav">
                        {categories.length > 0 && (
                            <nav className="footer-col" aria-label="Категорії запчастин">
                                <p className="footer-col-title">Категорії</p>
                                <ul className="footer-col-list">
                                    {categories.map(cat => (
                                        <li key={cat.id}>
                                            <Link
                                                to={`/zapchastyny/${cat.slug || cat.id}`}
                                                className="footer-link"
                                            >
                                                {cat.name}
                                            </Link>
                                        </li>
                                    ))}
                                </ul>
                            </nav>
                        )}

                        <nav className="footer-col" aria-label="Інформація">
                            <p className="footer-col-title">Інформація</p>
                            <ul className="footer-col-list">
                                <li><Link to="/about" className="footer-link">Про нас</Link></li>
                                <li><Link to="/contacts" className="footer-link">Контакти</Link></li>
                                <li><Link to="/reviews" className="footer-link">Відгуки</Link></li>
                                <li><Link to="/return-policy" className="footer-link">Гарантія та повернення</Link></li>
                                <li><Link to="/payment" className="footer-link">Оплата та доставка</Link></li>
                                <li><Link to="/privacy-policy" className="footer-link">Політика конфіденційності</Link></li>
                            </ul>
                        </nav>

                        <div className="footer-col" aria-label="Контакти">
                            <p className="footer-col-title">Контакти</p>
                            <ul className="footer-col-list">
                                {COMPANY_PHONES.map(({ number, display }) => (
                                    <li key={number}>
                                        <CopyPhoneText number={number} className="footer-link">
                                            {display}
                                        </CopyPhoneText>
                                    </li>
                                ))}
                                <li><a href={`mailto:${COMPANY_EMAIL}`} className="footer-link">{COMPANY_EMAIL}</a></li>
                                <li><span className="footer-link footer-link--static">{COMPANY_ADDRESS}</span></li>
                            </ul>
                        </div>
                    </div>
                )}

                <div className="footer-bottom">
                    <p className="footer-copy">© {year} UnionAuto. Усі права захищені.</p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
